<div class="mb-4 sign-up-overview-description">
  {{ description }}
</div>

<div class="mb-4">
  <ds-link
    href="https://client.levelaccess.com/hc/en-us/articles/12507620329111-User-groups"
    [external]="true"
    [standalone]="true"
    data-test-id="sign-up-overview-learn-more"
  >
    {{ 'sign_up_overview_learn_more' | translate }}
  </ds-link>
</div>

<div class="mb-5">
  <ul class="sign-up-overview-workspace-list fa-ul">
    @for (workspace of userWorkspaces; track workspace) {
      <li class="mb-4">
        <span class="fa-li">
          <ds-icon [icon]="Icons.Briefcase" [iconStyle]="IconStyles.Light"></ds-icon>
        </span>
        {{ workspace.name }}
        <ul class="sign-up-overview-website-list">
          @for (websiteAppName of workspace.websiteAppNames; track websiteAppName) {
            <li>
              {{ websiteAppName }}
            </li>
          }
        </ul>
      </li>
    }
  </ul>
</div>

<div>
  <button type="button" ds-button [variant]="DsButtonVariants.primary" (click)="onSubmit()" data-test-id="sign-up-submit">
    {{ 'sign_up_finish' | translate }}
  </button>
</div>
